import React from 'react';

import AddCompany from '../component-add-company';

export default class AddCompanyPage extends React.Component {
    render() {
        return (
            <AddCompany />
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Companies/containers/container-add-company.js